import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Sofía Martínez',
  image: 'https://cdn.magicpatterns.com/uploads/4hPEZHDmTnoXoUTjx27Uun/56ec1f13-173c-4cb8-8624-08165c6cfeb8.webp'
}, {
  name: 'Julieta Pereira',
  image: 'https://cdn.magicpatterns.com/uploads/eZxaCuecj8ddronCoVyc5z/36f14477-94fe-4aad-8e8a-ffbf6c7c9b24.webp'
}, {
  name: 'Facundo Morales',
  image: 'https://cdn.magicpatterns.com/uploads/g1rifCs3nFaNb5Fub6eG2N/9ea907ca-f783-4095-9aa7-92aedd1dc761.webp'
}];
export function Testimonials() {
  return <section className="w-full bg-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-217">
      <div className="max-w-5xl mx-auto" data-id="element-218">
        <div className="text-center mb-16" data-id="element-219">
          <span className="text-primary font-bold tracking-widest text-sm uppercase mb-3 block" data-id="element-220">
            Testimonios reales
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-black text-navy mb-4" data-id="element-221">
            Lo que dicen los profes que lo usan
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-16" data-id="element-222">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="w-full max-w-[220px] mx-auto rounded-3xl overflow-hidden shadow-xl border border-gray-200/50 bg-white" data-id="element-223">
              <img src={t.image} alt={`Testimonio de ${t.name} sobre el ProfePack`} className="w-full h-auto block" loading="lazy" data-id="element-224" />
            </motion.div>)}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 max-w-3xl mx-auto text-center divide-x divide-gray-200" data-id="element-225">
          <div data-id="element-226">
            <div className="text-3xl sm:text-4xl font-heading font-black text-navy mb-1" data-id="element-227">
              500+
            </div>
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-228">
              Clientes
            </div>
          </div>
          <div data-id="element-229">
            <div className="text-3xl sm:text-4xl font-heading font-black text-navy mb-1 flex items-center justify-center gap-1" data-id="element-230">
              4.9 <Star className="w-5 h-5 text-primary fill-primary" data-id="element-231" />
            </div>
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-232">
              Calificación
            </div>
          </div>
          <div data-id="element-233">
            <div className="text-3xl sm:text-4xl font-heading font-black text-navy mb-1" data-id="element-234">
              100%
            </div>
            <div className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-235">
              Satisfacción
            </div>
          </div>
        </div>
      </div>
    </section>;
}